import React from 'react';
import { useRouter } from 'next/router';
import { isNoticiesPath, is3catPath } from 'utils/pathHelper';
import Error3catinfo from './_error3catinfo';
import Error3cat from './_error3cat';
import ErrorCorporatiu from './_errorCorporatiu';

const ErrorPage = (props) => {
    const { statusCode } = props;
    const router = useRouter();
    const isNoticies = isNoticiesPath(router.asPath);
    const is3cat = is3catPath(router.asPath);

    if (isNoticies) {
        return <Error3catinfo statusCode={statusCode} asPath={router.asPath} />;
    } else if (is3cat) {
        return <Error3cat statusCode={statusCode} asPath={router.asPath} />;
    } else {
        return <ErrorCorporatiu statusCode={statusCode} asPath={router.asPath} />;
    }
};

ErrorPage.getInitialProps = async ({ res, err }) => {
    let statusCode = 404;
    if (res) {
        statusCode = res.statusCode;
    } else if (err) {
        statusCode = err.statusCode;
    }
    return { statusCode };
};

export default ErrorPage;
